/**
 * @GENERATED from Figma node 3608:51018
 */

import * as React from "react";
export type IconProps = Omit<React.SVGProps<SVGSVGElement>, "color">;
const GreenhouseDark = (props: IconProps, ref: React.Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    focusable={false}
    role="presentation"
    ref={ref}
    {...props}
  >
    <path
      fill="#23A47F"
      d="M12 13.457c1.445 0 2.51 1.114 2.51 2.493A2.473 2.473 0 0 1 12 18.443a2.47 2.47 0 0 1-2.51-2.493c0-1.379 1.065-2.493 2.51-2.493M12 7.327c.905 0 1.649.725 1.649 1.602s-.744 1.602-1.649 1.602-1.649-.725-1.649-1.602.744-1.602 1.649-1.602"
    />
    <path
      fill="#23A47F"
      fillRule="evenodd"
      d="M3.667 2C2.747 2 2 2.746 2 3.667v16.666C2 21.253 2.746 22 3.667 22h16.666c.92 0 1.667-.746 1.667-1.667V3.667C22 2.747 21.254 2 20.333 2zm10.288 8.823c.525-.501.847-1.142.847-1.866 0-.828-.355-1.318-.62-1.685-.158-.219-.285-.394-.285-.571 0-.251.204-.363.467-.446.32-.112.744-.348.744-.864a.907.907 0 0 0-.92-.891c-.51 0-.933.39-.933.864 0 .112.021.22.04.32.017.086.033.166.033.237 0 .264-.204.431-.598.431-.102 0-.213-.009-.332-.018a5 5 0 0 0-.442-.023c-1.517 0-2.758 1.17-2.758 2.618 0 .752.321 1.393.847 1.894.24.23.525.388.777.528.36.2.653.364.653.642 0 .327-.282.437-.696.597-.396.153-.913.354-1.42.838-.686.654-1.109 1.518-1.109 2.522 0 1.976 1.663 3.55 3.75 3.55s3.75-1.574 3.75-3.552c0-1.002-.423-1.866-1.109-2.52-.507-.484-1.024-.685-1.42-.838-.414-.16-.696-.27-.696-.597 0-.278.293-.441.653-.642.252-.14.537-.298.777-.528"
      clipRule="evenodd"
    />
    <path
      fill="#fff"
      fillRule="evenodd"
      d="M14.802 8.957c0 .724-.322 1.365-.847 1.866-.24.23-.525.388-.777.528-.36.2-.653.364-.653.642 0 .327.282.437.696.597.396.153.913.354 1.42.838.686.654 1.109 1.518 1.109 2.52 0 1.978-1.663 3.552-3.75 3.552s-3.75-1.574-3.75-3.55c0-1.004.423-1.868 1.109-2.522.507-.484 1.024-.685 1.42-.838.414-.16.696-.27.696-.597 0-.278-.293-.441-.653-.642-.252-.14-.537-.298-.777-.528-.526-.501-.847-1.142-.847-1.894 0-1.449 1.24-2.618 2.758-2.618.157 0 .305.012.442.023q.179.016.332.018c.393 0 .598-.167.598-.431 0-.071-.016-.15-.032-.236-.02-.1-.041-.209-.041-.321 0-.474.423-.864.934-.864.51 0 .919.404.919.891 0 .516-.423.752-.744.864-.263.083-.467.195-.467.446 0 .177.127.352.285.571.265.367.62.857.62 1.685m-1.153-.028c0-.877-.744-1.602-1.649-1.602s-1.649.725-1.649 1.602.744 1.602 1.649 1.602 1.649-.725 1.649-1.602m.86 7.02c0-1.378-1.064-2.492-2.509-2.492S9.49 14.57 9.49 15.95A2.47 2.47 0 0 0 12 18.443c1.445 0 2.51-1.13 2.51-2.493"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = React.forwardRef(GreenhouseDark);
export { ForwardRef as GreenhouseDark };
